"use strict";

const STORAGE_KEY = "api_environment";

export const API_ENVIRONMENTS = {
  local: {
    label: "Local",
    baseUrl: "http://localhost:3002/api/v1",
  },
  staging: {
    label: "Internal",
    baseUrl: "https://api-staging.affordamic.com/api/v1",
  },
  production: {
    label: "Staff",
    baseUrl: "https://api.affordamic.com/api/v1",
  },
};

export function getLoginEnvironmentOptions(kind = "staff") {
  return [
    { value: "staging", label: "Internal" },
    {
      value: "production",
      label: kind === "partner" ? "Partner" : "Staff",
    },
  ];
}

export function resolveSelectableApiEnvironment() {
  return getApiEnvironment() === "production" ? "production" : "staging";
}

export function getApiEnvironment() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && API_ENVIRONMENTS[stored]) {
    return stored;
  }
  return "staging";
}

export function setApiEnvironment(environment) {
  if (!API_ENVIRONMENTS[environment]) {
    throw new Error(`Invalid API environment: ${environment}`);
  }
  localStorage.setItem(STORAGE_KEY, environment);
}

export function getApiBaseUrl() {
  return API_ENVIRONMENTS[getApiEnvironment()].baseUrl;
}

export function getExamSocketUrl() {
  return getApiBaseUrl().replace(/\/api\/v1\/?$/, "");
}

export function getApiEnvironmentLabel(environment = getApiEnvironment()) {
  if (environment === "production") {
    const role =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("user_role")
        : "";
    return role === "partner" ? "Partner" : "Staff";
  }
  return "Internal";
}
